module.exports = __webpack_public_path__ + "assets/img/logo_01.2eec9c69.png";